import FJAiRecreateIcon from '../../../../assets/svg/community/ai-recreate.svg?react';
import PropTypes from 'prop-types';
import styles from './FJTemplateWorkItem.module.less';
import FJUtil from '../../../../util/FJUtil';
import FJCommunityMedia from '../FJCommunityMedia/FJCommunityMedia';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJButton, { FJButtonType } from '../../../../common/components/FJButton/FJButton';
import FJCommunityUtil from '../../../../util/FJCommunityUtil';
const FJTemplateWorkItem = props => {
    const { item = {}, onClick } = props;
    const {
        imgUrl = '',
        videoUrl = '',
        mediaType,

        coverImg = '',
        coverVideo = '',
    } = item;

    const _onClick = e => {
        FJUtil.forbidEvent(e);
        // onClick && onClick(item);
        FJCommunityUtil.onTemplateRecreate(item);
    };
    const _onAiRecreateClick = e => {
        FJUtil.forbidEvent(e);
        FJCommunityUtil.onTemplateRecreate(item);
    };
    const _renderInteractionContent = () => {
        return (
            <div className={styles.content_box}>
                <div className={styles.header}>
                    <span className={styles.title}>{FJLocalStore._('ai-template')}</span>
                </div>
                <div className={styles.footer}>
                    <FJButton
                        className={styles.recreate_btn}
                        type={FJButtonType.GRADIENT}
                        text={FJLocalStore._('recreate')}
                        rightIcon={<FJAiRecreateIcon className={styles.recreate_icon} />}
                        onClick={_onAiRecreateClick}
                        textClassName={styles.recreate_btn_text}
                    />
                </div>
            </div>
        );
    };
    return (
        <div className={styles.box} onClick={_onClick}>
            <FJCommunityMedia
                mediaType={mediaType}
                coverVideo={coverVideo}
                coverImg={coverImg}
                videoUrl={videoUrl}
                imgUrl={imgUrl}
            >
                {_renderInteractionContent()}
            </FJCommunityMedia>
        </div>
    );
};

FJTemplateWorkItem.propTypes = {
    item: PropTypes.object,
    onLikeClick: PropTypes.func,
    onClick: PropTypes.func,
    isMultipleSelect: PropTypes.bool,
    isSelected: PropTypes.bool,
    onDownloadClick: PropTypes.func,
    onShareSettingClick: PropTypes.func,
    onVideoEditClick: PropTypes.func,
    onDeleteClick: PropTypes.func,
    onSelected: PropTypes.func,
    guestUserInfo: PropTypes.shape({
        guestMode: PropTypes.bool,
    }),
};

export default FJTemplateWorkItem;
